export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8191.0c32e2cf.jpg";